import type { Database } from '@/shared/types';
import SearchStationResultItem from './SearchStationResultItem';

type StationSearchResult =
	Database['public']['Functions']['search_gas_stations']['Returns'][number];

type SearchStationResultListProps = {
	results: StationSearchResult[];
	highlight: string;
};

const SearchStationResultList = ({
	results,
	highlight,
}: SearchStationResultListProps) => {
	return (
		<section className="flex w-full flex-col">
			<ul className="w-full">
				{results.map((station) => (
					<SearchStationResultItem
						key={station.id}
						station={station}
						highlight={highlight}
					/>
				))}
			</ul>
		</section>
	);
};

export default SearchStationResultList;
